var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScrollTopComponent',[_c('a',[_c('img',{attrs:{"src":require("../assets/fleche_remonter.svg"),"alt":"Flèche pour remonter","width":"75%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }